export default "__VITE_ASSET__CPCV11OF__"